import type { useMenu } from '#hooks/menu.ts';

import { faFloppyDisk, faPencil, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeScalableIcon } from '@mend/mui';
import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';

interface SavedViewActionsMenuProps {
  menu: ReturnType<typeof useMenu>;
  isDirty: boolean;
  onSave: () => void;
  onRename: () => void;
  onDelete: () => void;
}

export function SavedViewActionsMenu(props: SavedViewActionsMenuProps) {
  function handleSave() {
    props.menu.close();
    props.onSave();
  }

  function handleRename() {
    props.menu.close();
    props.onRename();
  }

  function handleDelete() {
    props.menu.close();
    props.onDelete();
  }

  return (
    <Menu {...props.menu.getMenuProps()}>
      {props.isDirty && (
        <MenuItem onClick={handleSave}>
          <ListItemIcon>
            <FontAwesomeScalableIcon icon={faFloppyDisk} />
          </ListItemIcon>
          <ListItemText>Save</ListItemText>
        </MenuItem>
      )}
      <MenuItem onClick={handleRename}>
        <ListItemIcon>
          <FontAwesomeScalableIcon icon={faPencil} />
        </ListItemIcon>
        <ListItemText>Rename</ListItemText>
      </MenuItem>
      <MenuItem onClick={handleDelete}>
        <ListItemIcon>
          <FontAwesomeScalableIcon icon={faTrash} />
        </ListItemIcon>
        <ListItemText>Delete</ListItemText>
      </MenuItem>
    </Menu>
  );
}
